export function findMatchGroups(grid) {
  const rows = grid.length;
  const cols = grid[0].length;

  const groups = [];

  const addGroup = (cells) => {
    const uniq = [];
    const kset = new Set();
    for (const p of cells) {
      const k = `${p.r},${p.c}`;
      if (!kset.has(k)) {
        kset.add(k);
        uniq.push(p);
      }
    }
    if (uniq.length >= 3) groups.push(uniq);
  };

  for (let r = 0; r < rows; r++) {
    let runColor = null;
    let runStart = 0;

    for (let c = 0; c <= cols; c++) {
      const tile = c < cols ? grid[r][c] : null;
      const color = tile ? tile.color : null;

      if (color !== runColor) {
        const runLen = c - runStart;
        if (runColor && runLen >= 3) {
          const cells = [];
          for (let k = runStart; k < c; k++) cells.push({ r, c: k });
          addGroup(cells);
        }
        runColor = color;
        runStart = c;
      }
    }
  }

  for (let c = 0; c < cols; c++) {
    let runColor = null;
    let runStart = 0;

    for (let r = 0; r <= rows; r++) {
      const tile = r < rows ? grid[r][c] : null;
      const color = tile ? tile.color : null;

      if (color !== runColor) {
        const runLen = r - runStart;
        if (runColor && runLen >= 3) {
          const cells = [];
          for (let k = runStart; k < r; k++) cells.push({ r: k, c });
          addGroup(cells);
        }
        runColor = color;
        runStart = r;
      }
    }
  }

  const all = [];
  const set = new Set();
  for (const g of groups) {
    for (const p of g) {
      const k = `${p.r},${p.c}`;
      if (!set.has(k)) {
        set.add(k);
        all.push(p);
      }
    }
  }

  return { groups, all };
}

export function energyForGroupSize(n) {
  if (n >= 5) return 8;
  if (n === 4) return 5;
  if (n === 3) return 3;
  return Math.min(10, Math.round(n * 1.6));
}
